/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AccountRecovery,
    AccountRecoveryFromJSON,
    AccountRecoveryToJSON,
    ChangePassword,
    ChangePasswordFromJSON,
    ChangePasswordToJSON,
    CreateUser,
    CreateUserFromJSON,
    CreateUserToJSON,
    EmailVerification,
    EmailVerificationFromJSON,
    EmailVerificationToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ForgotPassword,
    ForgotPasswordFromJSON,
    ForgotPasswordToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    MemberList,
    MemberListFromJSON,
    MemberListToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
    User,
    UserFromJSON,
    UserToJSON,
} from '../models';

export interface ChangePasswordAccountRequest {
    ChangePassword: ChangePassword;
}

export interface FindMembersByUserProgramAccountRequest {
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    program_id?: string;
}

export interface RequestRecoveryEmailAccountRequest {
    AccountRecovery: AccountRecovery;
    origin?: string;
}

export interface ResetForgottenPasswordAccountRequest {
    id: string;
    ForgotPassword: ForgotPassword;
}

export interface SignupAccountRequest {
    CreateUser: CreateUser;
}

export interface UpdateCurrentUserAccountRequest {
    User: User;
}

export interface VerifyEmailAccountRequest {
    EmailVerification: EmailVerification;
}

export interface VerifyRecoveryCodeAccountRequest {
    id: string;
}

/**
 * 
 */
export class AccountApi extends runtime.BaseAPI {

    /**
     * Change current user\'s passwords
     */
    async changePasswordAccountRaw(requestParameters: ChangePasswordAccountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters.ChangePassword === null || requestParameters.ChangePassword === undefined) {
            throw new runtime.RequiredError('ChangePassword','Required parameter requestParameters.ChangePassword was null or undefined when calling changePasswordAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile/password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangePasswordToJSON(requestParameters.ChangePassword),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Change current user\'s passwords
     */
    async changePasswordAccount(requestParameters: ChangePasswordAccountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<User> {
        const response = await this.changePasswordAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find current user
     */
    async findByCurrentUserAccountRaw(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<User>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Find current user
     */
    async findByCurrentUserAccount(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<User> {
        const response = await this.findByCurrentUserAccountRaw(initOverrides);
        return await response.value();
    }

    /**
     * List all connected members
     */
    async findMembersByUserProgramAccountRaw(requestParameters: FindMembersByUserProgramAccountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<MemberList>> {
        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.program_id !== undefined) {
            queryParameters['program_id'] = requestParameters.program_id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile/members`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MemberListFromJSON(jsonValue));
    }

    /**
     * List all connected members
     */
    async findMembersByUserProgramAccount(requestParameters: FindMembersByUserProgramAccountRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<MemberList> {
        const response = await this.findMembersByUserProgramAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send account recovery request
     */
    async requestRecoveryEmailAccountRaw(requestParameters: RequestRecoveryEmailAccountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.AccountRecovery === null || requestParameters.AccountRecovery === undefined) {
            throw new runtime.RequiredError('AccountRecovery','Required parameter requestParameters.AccountRecovery was null or undefined when calling requestRecoveryEmailAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.origin !== undefined && requestParameters.origin !== null) {
            headerParameters['origin'] = String(requestParameters.origin);
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/recovery`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccountRecoveryToJSON(requestParameters.AccountRecovery),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Send account recovery request
     */
    async requestRecoveryEmailAccount(requestParameters: RequestRecoveryEmailAccountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestRecoveryEmailAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reset forgotten password
     */
    async resetForgottenPasswordAccountRaw(requestParameters: ResetForgottenPasswordAccountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling resetForgottenPasswordAccount.');
        }

        if (requestParameters.ForgotPassword === null || requestParameters.ForgotPassword === undefined) {
            throw new runtime.RequiredError('ForgotPassword','Required parameter requestParameters.ForgotPassword was null or undefined when calling resetForgottenPasswordAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/recovery/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ForgotPasswordToJSON(requestParameters.ForgotPassword),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Reset forgotten password
     */
    async resetForgottenPasswordAccount(requestParameters: ResetForgottenPasswordAccountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.resetForgottenPasswordAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verify an email confirmation link
     */
    async reverifyEmailAccountRaw(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reverify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Verify an email confirmation link
     */
    async reverifyEmailAccount(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.reverifyEmailAccountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Sign up user
     */
    async signupAccountRaw(requestParameters: SignupAccountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters.CreateUser === null || requestParameters.CreateUser === undefined) {
            throw new runtime.RequiredError('CreateUser','Required parameter requestParameters.CreateUser was null or undefined when calling signupAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/signup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserToJSON(requestParameters.CreateUser),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Sign up user
     */
    async signupAccount(requestParameters: SignupAccountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<User> {
        const response = await this.signupAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update current user
     */
    async updateCurrentUserAccountRaw(requestParameters: UpdateCurrentUserAccountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters.User === null || requestParameters.User === undefined) {
            throw new runtime.RequiredError('User','Required parameter requestParameters.User was null or undefined when calling updateCurrentUserAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserToJSON(requestParameters.User),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Update current user
     */
    async updateCurrentUserAccount(requestParameters: UpdateCurrentUserAccountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<User> {
        const response = await this.updateCurrentUserAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verify an email confirmation link
     */
    async verifyEmailAccountRaw(requestParameters: VerifyEmailAccountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters.EmailVerification === null || requestParameters.EmailVerification === undefined) {
            throw new runtime.RequiredError('EmailVerification','Required parameter requestParameters.EmailVerification was null or undefined when calling verifyEmailAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/verify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailVerificationToJSON(requestParameters.EmailVerification),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Verify an email confirmation link
     */
    async verifyEmailAccount(requestParameters: VerifyEmailAccountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<User> {
        const response = await this.verifyEmailAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verify account recovery code
     */
    async verifyRecoveryCodeAccountRaw(requestParameters: VerifyRecoveryCodeAccountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling verifyRecoveryCodeAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/recovery/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Verify account recovery code
     */
    async verifyRecoveryCodeAccount(requestParameters: VerifyRecoveryCodeAccountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.verifyRecoveryCodeAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
